export default "__VITE_ASSET__F9Ncw7VB__"